<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/classList'}">班级管理</el-breadcrumb-item>
      <el-breadcrumb-item>学员详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix" style="display: flex; align-items: center; gap: 20px;">
        <span style="font-size: 18px; font-weight: bold;">{{'班级：' + className}}</span>
        <span style="font-size: 18px; font-weight: bold;">{{'课程：' + courseName}}</span>
        <span style="font-size: 18px; font-weight: bold;">{{'教室：' + classRoom}}</span>
      </div>
      <!-- 查询框 -->
      <el-row :gutter="24">
        <el-col :span="4">
          <el-select v-model="queryInfo.classScheduleId" placeholder="请选择时间段">
            <el-option
              v-for="item in timeSelectList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryInfo.realnameOrPhone"
            @clear="loadData"
            placeholder="请输入手机号、姓名"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="queryInfo.grade" placeholder="年级">
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="queryInfo.subject" placeholder="科目">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-button @click="handleSearch" type="primary">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="dataList" stripe>
        <el-table-column label="学员姓名" prop="realname"></el-table-column>
        <el-table-column label="手机号码"  prop="phone"></el-table-column>
<!--        <el-table-column label="课程名称"  prop="courseName"></el-table-column>-->
<!--        <el-table-column label="班级名称"  prop="className"></el-table-column>-->
<!--        <el-table-column label="套餐名称"  prop="setMealName"></el-table-column>-->
<!--        <el-table-column label="上课教室"  prop="classRoom"></el-table-column>-->
<!--        <el-table-column label="上课时间"  prop="createTime"></el-table-column>-->
<!--        <el-table-column label="上课老师"  prop="teacherName"></el-table-column>-->
        <el-table-column label="所属学管"  prop="teacherManagerName"></el-table-column>
<!--        <el-table-column label="教师"  prop="teacherName"></el-table-column>-->
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleOffDuty(scope.row)" type="text" style="color:#F53F3F">退班</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 页数码 -->
        <!-- 页数码 -->
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="queryInfo.pageNo"
            :page-size="queryInfo.pageSize"
            :total="total"
            background
          ></el-pagination>
    </el-card>

    <!-- 退班二次确认弹窗 -->
    <el-dialog title="确定退班" :visible.sync="dialogFormVisibleOffDuty" :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleOffDuty = false">取 消</el-button>
        <el-button type="primary" @click="confirmDuty">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDate } from "../../../plugins/date.js";
  export default {
    data() {
      return {
        //用于获取数据列表
        queryInfo: {
          classId:'',
          grade: null,
          subject: '',
          classScheduleId:'',
          classType:null,
          isSchedule:null,
          realnameOrPhone:'',
          studentSelectFlag:2,
          pageSize: 10,
          pageNo: 1,
        },
        className: '',
        courseName: '',
        classRoom: '',
        // 确定入班
        dialogFormVisibleOffDuty:false,
        // 排课状态
        timeSelectList:[],
        // 选择套餐搜索
        classRelateStudentModel:{
          classId:'',
          studentIds:'',
          classScheduleId:''
        },
        gradeList: [{id: 2,name: '二年级'},
          {id: 3,name: '三年级'},
          {id: 4,name: '四年级'},
          {id: 5,name: '五年级'},
          {id: 6,name: '六年级'},
          {id: 7,name: '七年级'},
          {id: 8,name: '八年级'},
          {id: 9,name: '九年级'},
          {id: 10,name: '高一'},
          {id: 11,name: '高二'},
          {id: 12,name: '高三'}],
        subjectList: [{id: 1,name: '数学'},
          {id: 2,name: '语文'},
          {id: 3,name: '英语'},
          {id: 4,name: '科学'},
          {id: 5,name: '物理'},
          {id: 6,name: '化学'},
          {id: 7,name: '生物'}],
        dataList: [],
        total: 0,
      };
    },
    created() {
      this.queryInfo.classId = this.$route.query.classId?this.$route.query.classId:'';
      this.queryInfo.classType = this.$route.query.classType?this.$route.query.classType:'';
      this.loadData();
      this.queryScheduleById();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // 数据加载
      async loadData() {
        let url = "/ea/student/classClass/getStudentList";
        if( this.queryInfo.classType == 1){
          url = "/ea/student/classOneOnOne/getStudentList"
        }
        const { data: res } = await this.$http.post(url,this.queryInfo);
        if (res.code !== 200){ return this.$message.error(res.message);}
        this.dataList = res.result.records;
        this.total = res.result.total;
        if(this.dataList && this.dataList.length > 0){
          this.className = this.dataList[0].className;
          this.courseName = this.dataList[0].courseName;
          this.classRoom = this.dataList[0].classRoom;
        }
      },
      // 删除
      handleDelete(row){
        this.$confirm('此操作将永久删除该学生, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
       // 班级排课查询
      async queryScheduleById(){
        this.timeSelectList = [];
        let id = this.queryInfo.classId;
        let idModel = {
          id:id,
        };
        const { data: res } = await this.$http.post(`/ea/student/classClass/queryScheduleById`,idModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        let list  = res.result;
        list.map(e=>{
          let item = {
            label:e.startDates+'/'+e.beginTime+'-'+e.startDates+'/'+e.endTime,
            value:e.id
          };
          this.timeSelectList.push(item);
        })
      },
      // 搜索
      handleSearch(){
        this.loadData();
      },
      // 切换页码
      handleCurrentChange(page) {
        this.queryInfo.pageNum = pageNum;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.queryInfo.pageSize = pageSize;
        this.loadData();
      },
      // 退班
      handleOffDuty(row){
        this.classRelateStudentModel.studentIds = row.id;
        this.classRelateStudentModel.classId = this.queryInfo.classId;
      //   this.dialogFormVisibleOffDuty = true;
      // },
      // // 选择时间后退班
      // confirmDuty(){
        this.$confirm('此操作将永久退出该班课班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.removeStudent();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      // 学员退班
      async removeStudent(){
        const { data: res } = await this.$http.post(`/ea/student/classClass/removeStudent`,this.classRelateStudentModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.$message({
          type: 'success',
          message: res.message
        });
        await this.loadData()
        this.dialogFormVisibleOffDuty = false;
      },
    },
  };
</script>

<style lang="less" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px #8c939d dashed;
    border-radius: 3px;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  /deep/ .el-table--border {
    border-bottom: 1px solid #ececec;
  }

  .statusBox h5 {
    font-size: 25px;
    color: #999;
    text-align: center;
  }

  .statusBox span {
    font-size: 25px;
    color: #1890ff;
    text-align: center;
    display: block;
    margin-bottom: 20px;
  }
</style>
